<div [ngClass]="{'blur': successModel}">
  <!-- Main Invoice Content -->
  <div *ngIf="isCreate">
    <form [formGroup]="createinvoiceForm">
      <div class="invoice-wrapper">
        <div class="invoice-container">
          
          <!-- Invoice Header Section -->
          <div class="invoice-header-row">
            <!-- Left: Logo and Address -->
            <div class="left-section">
              <div class="logo-wrapper" *ngIf="imageToShow">
                <img [src]="imageToShow"  *ngIf="isShowImage" alt="Logo" class="company-logo" (error)="onImageError()"/>
              </div>
              <div class="address-card">
                <div class="address-text">{{invoice?.from_address?.house_flat_no}}</div>
                <div class="address-text">{{invoice?.from_address?.street}}</div>
                <div class="address-text">{{invoice?.from_address?.city_town}}, {{invoice?.from_address?.state}}, {{invoice?.from_address?.country}}, {{invoice?.from_address?.zipcode}}</div>
              </div>
            </div>

            <!-- Right: Invoice Details Grid -->
            <div class="right-section">
              <div class="details-grid">
                <!-- Row 1 -->
                <div class="grid-row">
                  <div class="grid-col">
                    <label class="field-label">Invoice No</label>
                    <input type="text" class="field-input" [value]="invoice?.invoice_no || 'N/A'" readonly>
                  </div>
                  <div class="grid-col">
                    <label class="field-label">GST</label>
                    <input type="text" class="field-input" [value]="invoice?.firm_gst_no || 'N/A'" readonly>
                  </div>
                </div>

                <!-- Row 2 -->
                <div class="grid-row">
                  <div class="grid-col">
                    <label class="field-label">Invoice Date</label>
                    <input type="text" class="field-input" [value]="invoice?.date || 'N/A'" readonly>
                  </div>
                  <div class="grid-col">
                    <label class="field-label">PAN</label>
                    <input type="text" class="field-input" [value]="invoice?.firm_pan_no || 'N/A'" readonly>
                  </div>
                </div>

                <!-- Row 3 -->
                <div class="grid-row">
                  <div class="grid-col">
                    <label class="field-label">Due Date</label>
                    <input type="text" class="field-input" [value]="invoice?.duedate || 'N/A'" readonly>
                  </div>
                  <div class="grid-col">
                    <label class="field-label">Client GST</label>
                    <input type="text" class="field-input" [value]="invoice?.client_gst_no || 'N/A'" readonly>
                  </div>
                </div>

                <!-- Row 4 -->
                <div class="grid-row">
                  <div class="grid-col">
                    <label class="field-label">Selected Client</label>
                    <input type="text" class="field-input" [value]="invoice?.name || 'N/A'" readonly>
                  </div>
                  <div class="grid-col">
                    <label class="field-label">Client PAN</label>
                    <input type="text" class="field-input" [value]="invoice?.client_pan_no || 'N/A'" readonly>
                  </div>
                </div>

                <!-- Row 5 -->
                <div class="grid-row">
                  <div class="grid-col">
                    <label class="field-label">Selected Matter</label>
                    <input type="text" class="field-input" [value]="invoice?.matters[0]?.name" readonly>
                  </div>
                   <div class="grid-col">
                    <label class="field-label">Client Address</label>
                    <input type="text" class="field-input" [value]="invoice?.billto" readonly>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Items Table -->
          <div class="table-wrapper">
            <table class="invoice-table">
              <thead>
                <tr>
                  <th class="col-sno">Sl.No.</th>
                  <th class="col-desc">Description</th>
                  <th class="col-rate">Rate</th>
                  <th class="col-qty">Qty</th>
                  <th class="col-amount">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of inItems; let i = index">
                  <td class="cell-center">{{ i + 1 }}</td>
                  <td class="cell-desc">{{item.name}}</td>
                  <td class="cell-center">{{selectedCurrency?.symbol}} {{item.unit_price}}</td>
                  <td class="cell-center">{{item.no_of_units}}</td>
                  <td class="cell-center">{{selectedCurrency?.symbol}} {{calculateAmount(item)}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Bottom Section: Additional Details and Totals -->
          <div class="bottom-wrapper">
            <!-- Left: Additional Details -->
            <div class="details-left">
              <div class="details-title">Additional Details</div>
              <div class="details-notes">
                {{invoice?.notes}}
              </div>
              <div class="thank-you-text">
                THANK YOU FOR YOUR BUSINESS!
              </div>
            </div>

            <!-- Right: Totals -->
            <div class="totals-right">
              <div class="totals-card">
                <div class="totals-row">
                  <span class="totals-label">Sub Total</span>
                  <span class="totals-value">{{selectedCurrency?.symbol}} {{ calculateTotalAmount() }}</span>
                </div>

                <div class="totals-row" *ngIf="inDis" style="border-bottom: none !important;">
                  <span class="totals-label">{{inDis?.discount_type || 'Discount'}}</span>
                  <span class="totals-value">{{inDis?.discount}} %</span>
                </div>

                <div class="totals-row" *ngIf="inTax">
                  <span class="totals-label">{{inTax?.tax_type || 'Tax'}}</span>
                  <span class="totals-value">{{inTax?.tax}} %</span>
                </div>

                <div class="totals-row totals-final">
                  <span class="totals-label">Total</span>
                  <span class="totals-value">{{selectedCurrency?.symbol}} {{ calculateTotalAmountWithOthers() | number: '1.2-2' }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="button-row">
            <button [routerLink]="['/invoice']" class="btn-action btn-back">Back</button>
            <button type="button" (click)="downloadDoc(invoice?.docid)" class="btn-action btn-download">Download</button>
          </div>

          <!-- Footer -->
          <div class="invoice-footer">
            <span class="footer-text">Website: {{profile?.website || ''}}</span>
            <span class="footer-text">Email: {{profile?.email || ''}}</span>
          </div>

        </div>
      </div>
    </form>
  </div>
</div>

<!-- Share Dialog Modal -->
<div class="modal" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" 
  aria-hidden="true" style="display:block;" *ngIf='successModel'>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-body">
        <button type="button" class="btn-close pull-right" (click)="btnclose()" style="float: right; padding:10px;"
          aria-label="Close"></button>
        <div class="alertpara alertparatxt sharewith"> Share With: {{invoice?.data.name}} </div>
        <div class="alertexted via spaceBlock"> Via
          <mat-checkbox color="primary"> <p class="chcktxt">Lex-Z Lawyers(Secure)</p> </mat-checkbox>
          <mat-checkbox color="primary"> <p class="chcktxt">Email</p> </mat-checkbox>
        </div>
        <div class="container message"> Message (optional) 
          <textarea rows="4" class="form-control textboxed txttxt spaceBlock"> </textarea>
        </div>
        <div class="alertbutton diaPad">
          <button class="btn btn-default btncancel btnrightitem" (click)="btnclose()">Cancel</button>
          <button class="btn btn-primary btnsave bbtn savecls">Send</button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Success Modal -->
<!-- <jw-modal id="doc-download-success" class="doc-del-success alert-box">
  <div class="doc-iframe-scs-body">
    <div class="container">
      <div class="row">
        <div class="alertbox">
          <div class="close-x float-right" style="cursor: pointer;" (click)="closeModal('doc-download-success');">X</div>
          <div class="alertpara">
            <p class="alertparatxt"> Success</p>
          </div>
          <div class="alertext congText">Congratulations!<br>You have successfully downloaded the Invoice.</div>
          <div class="center">
            <button class="btn btn-primary" (click)="closeModal('doc-download-success')">OK</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</jw-modal> -->